import { render, staticRenderFns } from "./Analytics.vue?vue&type=template&id=a8ec9298&scoped=true&"
import script from "./Analytics.vue?vue&type=script&lang=js&"
export * from "./Analytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ec9298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a8ec9298', component.options)
    } else {
      api.reload('a8ec9298', component.options)
    }
    module.hot.accept("./Analytics.vue?vue&type=template&id=a8ec9298&scoped=true&", function () {
      api.rerender('a8ec9298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/clients/Analytics.vue"
export default component.exports